import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import {
  applyBatteryConcertApplicationStatus,
  invalidateBatteryConcertApplication,
} from "./battery-concert-application-cache"
import type { BatteryConcertApplicationStatusDto } from "../dto/battery-concert-application.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Send the generated Concert loan documents for signature. The server holds
 * the claim and checks Concert's own readiness, so a retry cannot email the
 * homeowner twice while the first send is still in flight.
 */
export default function useSendBatteryConcertLoanDocuments(): UseMutationResult<
  BatteryConcertApplicationStatusDto,
  unknown,
  { proposalId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId }) =>
      batteryProposalService.sendConcertLoanDocuments(proposalId),
    onSuccess: (status, { proposalId }) => {
      applyBatteryConcertApplicationStatus(queryClient, proposalId, status)
    },
    onError: (_error, { proposalId }) => {
      invalidateBatteryConcertApplication(queryClient, proposalId)
    },
  })
}
